import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import $ from 'jquery'
import Toasted from 'vue-toasted'

Vue.use(Toasted, {
  theme: 'bubble',
  position: 'top-right',
  duration: 5000,
})

Vue.use(Vuex)
Vue.prototype.axios = axios

export default new Vuex.Store({
  state: {
    vendors: [],
    vendor: localStorage.getItem('vendor') || null,
    userData: {
      selectedVendor: localStorage.getItem('vendor') || '',
      year: '',
      make: '',
      model: '',
      trim: '',
      vehicleStyle: '',
      carDetails: '',
      odometerReading: '',
      vin: '',
      selectedRepair: '',
      invoiceBeforeTax: '',
      principalAmount: '',
      newAPR: '',
      vendorToPay: '',
      firstPaymentDay: '',
      totalPayments: '',
      loanRequested: '',
      costOfFinancing: '',
      frequencyOfPayments: '',
      frequencyText: '',
      repairOfferAmount: '',
      cashBack: '',
      marketValue: '',
      dataCertainty: '',
      approvedLoanAmount: '',
      boundaryAmount: '',
      payment: 0,
      ninetyDays: false,
      paymentFrequency: 'Semi-monthly',
      paymentPeriod: '24',
      numberOfPayments: 0,
      paymentTotal: 0,
      paymentFees: 0,
      loanApr: 0,
      term: '24',
      metric: 'km',
      vinFail: false,
      registered: false,
      title: false,
      sline: false,
    },
  },
  mutations: {
    setVendors(state, vendors) {
      console.log('Mutating vendors:', vendors)
      state.vendors = vendors
    },
    SET_SELECTED_VENDOR(state, vendorId) {
      state.userData.selectedVendor = vendorId
    },
    // Mutation to update vendor coordinates in the state
    updateVendorCoordinates(state, { vendorId, latitude, longitude }) {
      const vendor = state.vendors.find(v => v._id === vendorId)
      if (vendor) {
        Vue.set(vendor, 'latitude', latitude)
        Vue.set(vendor, 'longitude', longitude)
      }
    },
  },
  actions: {
    async fetchVendors({ commit }) {
      try {
        const { data } = await axios.get(`${process.env.ROOT_API}/search/combinedData`)
        console.log('Fetched vendors from API:', data)
        commit('setVendors', data)
        return data
      } catch (error) {
        Vue.toasted.show('An error occurred while fetching vendors, please try again')
        console.error('Error fetching vendors:', error)
      }
    },
    async geocodeVendor({ commit }, vendorId) {
      try {
        const response = await axios.post(`${process.env.ROOT_API}/vendor/geocode`, { vendorId })
        const data = response.data
        if (data && data.success) {
          // Update vendor coordinates in the state
          commit('updateVendorCoordinates', {
            vendorId,
            latitude: data.latitude,
            longitude: data.longitude,
          })
        }
        return data
      } catch (error) {
        console.error('Error geocoding vendor:', error)
        return { success: false }
      }
    },
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js